import { axiosInstance } from "authProvider";
import { API_URL } from "../../constants";

export const getClients = () => async (): Promise<[]> => {
  return await axiosInstance
    .get(`${API_URL}/api/clients?populate=*`)
    .then(({ data }) => data);
};
